
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { Variable } from "@/oxygen/variables/lib/types";
import VariableIcon from "@/oxygen/variables/VariableIcon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { openUiPanel } from "@/lib/panels/panels";
import VariableChooser from "@/oxygen/variables/VariableChooser.vue";
import DynamicDataChooser from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataChooser.vue";
import { ColorPickerType } from "@/types/colors";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    DynamicDataChooser,
    VariableChooser,
    NiceButton,
    VariableIcon,
    Dropdown
  }
})
export default class VariableChip extends Vue {
  @Prop()
  globalVariable!: Variable;

  @Prop()
  value!: string;

  @Prop()
  type!: string;

  @Prop()
  path!: string;

  @Prop({ default: 10 })
  iconSize!: number;

  @Prop()
  colorType?: ColorPickerType;

  @Prop({ default: false })
  small!: boolean;

  globalVariableChosen(name: string) {
    this.$emit("input", name);
  }

  get classes() {
    return {
      "variables-input-chip": true,
      "variables-input-chip--small": this.small,
      "variables-input-chip--default": !this.small,
      "variables-input-chip--deleted": !this.globalVariable
    };
  }

  clear() {
    this.$emit("input", null);
  }

  openPanel() {
    openUiPanel("variables");
  }
}
